module.exports = __webpack_public_path__ + "assets/webgl/card_069_DE_L0.jpg.26d05d49.webp";